import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from '../../store';
import { useFetchPaymentMethods } from '../../hooks/useFetchPaymentMethods';
import { InteractionName } from '../../types/InteractionName';
import { WidgetInternalProps } from '../../types/WidgetProps';
import { useFedopsLogger } from '../Hoc/Fedops/FedopsProvider';
import { useBiLogger } from '../Hoc/BiLogger/BiLoggerProvider';
import { selectGooglePayDto, selectIsAppDataLoaded } from '../../selectors';
import { checkApHighestSupportedVersion } from '../../actions/checkApHighestSupportedVersion';
import { checkApCanMakePayments } from '../../actions/checkApCanMakePayments';
import { getGooglePayOptions } from '../../actions/googlePay/getGooglePayOptions';
import { loadExperiments } from '../../actions/loadExperiments';
import { ResourcesLoader } from '../ResourcesLoader';
import { Container } from './elements';

export const WidgetController: React.FC<WidgetInternalProps> = (props) => {
  const [isAppLoaded, setAppLoaded] = useState<boolean>(false);
  const dispatch = useDispatch();
  const fedopsLogger = useFedopsLogger();
  const biLogger = useBiLogger();
  const isAppDataLoaded = useSelector(selectIsAppDataLoaded);
  const googlePayDTO = useSelector(selectGooglePayDto);

  useFetchPaymentMethods(props);

  useEffect(() => {
    if (isAppDataLoaded) {
      setAppLoaded(true);
    }
  }, [isAppDataLoaded]);

  useEffect(() => {
    dispatch(loadExperiments(props.preloadingData.experiments.all()));
    fedopsLogger.interactionStarted(InteractionName.FMP);
    dispatch(checkApHighestSupportedVersion());
    dispatch(checkApCanMakePayments());
  }, []);

  useEffect(() => {
    if (googlePayDTO) {
      dispatch(getGooglePayOptions({ fedopsLogger, biLogger }));
    }
  }, [biLogger, dispatch, fedopsLogger, googlePayDTO]);

  return <Container>{isAppLoaded && <ResourcesLoader />}</Container>;
};

WidgetController.displayName = 'WidgetController';
